var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition-group',{staticClass:"top-bar-controls-group",attrs:{"tag":"div","name":"top-bar-controls-group__transition","mode":"out-in"}},_vm._l((_vm.controls),function(control){return _c(control.component,_vm._g(_vm._b({key:control.key,tag:"component"},'component',control.props,false),{
      [control.eventName]: control.eventHandler,
    }))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }